import Clipboard from "clipboard";

// https://github.com/sadiqmmm/clipboard-rails#add-tooltips--highlight-animation
$(document).on("turbolinks:load", function() {
  // Tooltip
  $("#btn-clipboard").tooltip({
    trigger: "click",
    placement: "bottom"
  });

  function setTooltip(btn, message) {
    $(btn).tooltip("hide")
      .attr("data-original-title", message)
      .tooltip("show");
  }

  function hideTooltip(btn) {
    setTimeout(function() {
      $(btn).tooltip("hide");
    }, 1000);
  }

  // Clipboard
  var clipboard = new Clipboard("#btn-clipboard");

  clipboard.on("success", function(e) {
    setTooltip(e.trigger, "クリップボードにコピーしました");
    hideTooltip(e.trigger);
  });

  clipboard.on("error", function(e) {
    setTooltip(e.trigger, "クリップボードへのコピーに失敗しました");
    hideTooltip(e.trigger);
  });
});
